'use strict';

import React from 'react';

class LearnMoreConfirmation extends React.Component {

  render() {
    return (
      <div className='learn-more-confirmation-container flex-column align-center flex-center'>
        <img src={require('../../images/confirmationCheckmark.png')} className='confirmation-checkmark' />
        <div className='confirmation-text'>
          Thanks for expressing your interest.
        </div>
        <div className='confirmation-text'>
          We'll get back to you shortly.
        </div>
      </div>
    );
  }
}

LearnMoreConfirmation.displayName = 'LearnMoreConfirmation';

export default LearnMoreConfirmation;



// WEBPACK FOOTER //
// ./src/components/pages/LearnMoreConfirmation.js